import React from 'react'
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { router, usePage } from '@inertiajs/react'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'
import StatusBadge from '../../../../components/ui/StatusBadge'
import FormattedCurrency from '../../../../components/ui/FormattedCurrency'

Index.layout = (page) => <AppShell>{page}</AppShell>

export default function Index({ property, budget_plans }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/properties/${property.id}`

  return (
    <Box>
      <PageHeader
        title={property.management_type === 'weg' ? 'Wirtschaftspläne' : 'Budgetpläne'}
        breadcrumbs={[
          { label: property.name, href: basePath },
          { label: property.management_type === 'weg' ? 'Wirtschaftspläne' : 'Budgetpläne' },
        ]}
        actions={
          <Button variant="contained" size="small" startIcon={<AddIcon />}
            onClick={() => router.visit(`${basePath}/budget_plans/new`)}
            data-testid="new-budget-plan-btn"
          >
            {property.management_type === 'weg' ? 'Neuer Wirtschaftsplan' : 'Neuer Budgetplan'}
          </Button>
        }
      />

      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'background.subtle' }}>
              <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Geschäftsjahr</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Positionen</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Gesamtbetrag</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {budget_plans.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                  <Typography color="text.secondary">Keine Pläne vorhanden.</Typography>
                </TableCell>
              </TableRow>
            )}
            {budget_plans.map((bp) => (
              <TableRow key={bp.id} hover sx={{ cursor: 'pointer' }}
                onClick={() => router.visit(`${basePath}/budget_plans/${bp.id}`)}
              >
                <TableCell>{bp.name}</TableCell>
                <TableCell>{bp.fiscal_year_label}</TableCell>
                <TableCell>{bp.line_items_count}</TableCell>
                <TableCell align="right"><FormattedCurrency value={bp.total_amount} /></TableCell>
                <TableCell><StatusBadge type="budget_plan_status" value={bp.status} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
